import { MESSAGE } from "./msg-constants";
import { CALLER } from "./caller";
import { SelectionDataDto } from "./selection-data-dto";
import { ImageDataDto } from "./image-data-dto";

export class ShellMessage {
  public msgType: string = '';
  public fromGuid: string = '';
  public msgData: any;

  constructor(msgType: string, fromGuid: string, msgData: any) {
    this.msgType = msgType;
    this.fromGuid = fromGuid;
    this.msgData = msgData;
  }
}

export class ModuleStartedMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.MODULE_STARTED, fromGuid, {});
  }
}

export class OpenFromDrive extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.OPEN_FROM_DRIVE, fromGuid, msgData);
  }
}

export class ChoosenFromDrive extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.CHOOSEN_FILE_DRIVE, fromGuid, msgData);
  }
}

export class ModuleReadyMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string) {
    super(MESSAGE.MSGTYPE.MODULE_READY, fromGuid, { docId: docId });
  }
}

export class CredentialsRequestMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.CREDENTIAL_REQUEST, fromGuid, msgData);
  }
}

export class CredentialsResponseMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.CREDENTIAL_RESPONSE, fromGuid, msgData);
  }
}

export class CredentialsMissingMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.CREDENTIAL_MISSING, fromGuid, msgData);
  }
}

export class CredentialsChangedMessage extends ShellMessage {
  constructor(msgData: any) {
    super(MESSAGE.MSGTYPE.CREDENTIAL_CHANGED, '', msgData);
  }
}


export class UserLogoutMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.USER_LOGOUT, fromGuid, msgData);
  }
}

export class UserLoggedOutMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.USER_LOGGED_OUT, fromGuid, msgData);
  }
}

export class InteractionMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.INTERACTION, fromGuid, msgData);
  }
}

export class DirtyStateMessage extends ShellMessage {
  constructor(fromGuid: string, dirtyStatus: boolean) {
    super(MESSAGE.MSGTYPE.DIRTY_STATE, fromGuid, { dirtyStatus: dirtyStatus });
  }
}

export class SaveStatusMessage extends ShellMessage {
  constructor(fromGuid: string, saveStatus: number) {
    super(MESSAGE.MSGTYPE.SAVE_STATUS, fromGuid, { saveStatus: saveStatus });
  }
}

export class BusyMessage extends ShellMessage {
  constructor(fromGuid: string, busyStatus: boolean) {
    super(MESSAGE.MSGTYPE.BUSY_STATUS, fromGuid, { busyStatus: busyStatus });
  }
}

export class NameRequestMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string) {
    super(MESSAGE.MSGTYPE.DOC_NAME_REQUEST, fromGuid, { docId: docId });
  }
}

export class NameResponseMessage extends ShellMessage {
  constructor(fromGuid: string, docName: string) {
    super(MESSAGE.MSGTYPE.DOC_NAME_RESPONSE, fromGuid, { docName: docName });
  }
}

export class NotifyTargetDocMessage extends ShellMessage {
  constructor(
    fromGuid: string,
    sideDocId: string,
    sideDocType: string,
    sideDocName: string
  ) {
    super(MESSAGE.MSGTYPE.NOTIFY_TARGET_DOC, fromGuid, {
      sideDocId: sideDocId,
      sideDocType: sideDocType,
      sideDocName: sideDocName,
    });
  }
}
export class OpenWindowMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.OPEN_WINDOW, fromGuid, msgData);
  }
}

export class GoHomeMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.GOTO_HOME, fromGuid, {});
  }
}

export class FocusRequestMessage extends ShellMessage {
  constructor(guid: string) {
    super(MESSAGE.MSGTYPE.REQUEST_FOCUS, '', { focusId: guid });
  }
}

export class DocNameChangedMessage extends ShellMessage {
  constructor(docId: string, docName: string) {
    super(MESSAGE.MSGTYPE.DOC_NAME_CHANGED, '', { docId: docId, docName: docName });
  }
}


export class OpenLinkMessage extends ShellMessage {
  constructor(link: string) {
    super(MESSAGE.MSGTYPE.OPEN_LINK, '', { link: link });
  }
}

export class SaveDocRequestMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string) {
    super(MESSAGE.MSGTYPE.SAVE_DOC_REQUEST, fromGuid, { docId: docId });
  }
}

export class SaveDocResponseMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string, canClose: boolean) {
    super(MESSAGE.MSGTYPE.SAVE_DOC_RESPONSE, fromGuid, { docId: docId, canClose: canClose });
  }
}

export class CloseModuleMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.CLOSE, fromGuid, {});
  }
}

export class ShowShareDialogMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string, docType: string, name: string, showClassroom: boolean, isShared: boolean, showOnlyQrCode: boolean) {
    const msgData = {
      docId: docId,
      docType: docType,
      name: name,
      showClassroom: showClassroom,
      isShared: isShared,
      showOnlyQrCode: showOnlyQrCode
    }
    super(MESSAGE.MSGTYPE.SHOW_SHARE_DIALOG, fromGuid, msgData);
  }
}

export class SetLoadingStatus extends ShellMessage {
  constructor(fromGuid: string, isLoading: boolean, loadingId: string = '', message: string = '', progress: number = -1) {
    super(MESSAGE.MSGTYPE.SET_LOADING_STATUS, fromGuid, { isLoading: isLoading, loadingId: loadingId, message: message, progress: progress });
  }
}

export class SetInitialStateMessage extends ShellMessage {
  constructor(fromGuid: string, state: any) {
    super(MESSAGE.MSGTYPE.SET_INITIAL_STATE, fromGuid, { state: state });
  }
}

export class GetInitialStateMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.GET_INITIAL_STATE, fromGuid, {});
  }
}

export class CopyDocMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string, docName: string, previewPublicUrl: string) {
    super(MESSAGE.MSGTYPE.COPY_DOC, fromGuid, { docId: docId, docName: docName, previewPublicUrl: previewPublicUrl });
  }
}

export class OpenMapShowMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string) {
    super(MESSAGE.MSGTYPE.OPEN_MAP_SHOW, fromGuid, { docId: docId });
  }
}

export class SwitchToEditShowMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string, editShow: boolean) {
    super(MESSAGE.MSGTYPE.SWITCH_TO_EDIT_SHOW, fromGuid, { docId: docId, editShow: editShow });
  }
}

export class CreateMapDocMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string, html: string, filename: string, docFileId: string, message: string, action: string) {
    super(MESSAGE.MSGTYPE.CREATE_MAP_DOC_FILE, fromGuid,
      { docId: docId, html: html, filename: filename, docFileId: docFileId, message: message, action: action }
    );
  }
}

export class MapDocCreatedMessage extends ShellMessage {
  constructor(fromGuid: string, docFileId: string) {
    super(MESSAGE.MSGTYPE.MAP_DOC_FILE_CREATED, fromGuid, { docFileId: docFileId });
  }
}

export class OpenDocMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string) {
    super(MESSAGE.MSGTYPE.OPEN_DOC, fromGuid, { docId: docId });
  }
}

export class DocOpenedMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string) {
    super(MESSAGE.MSGTYPE.DOC_OPENED, fromGuid, { docId: docId });
  }
}

export class MathContentMessage extends ShellMessage {
  constructor(fromGuid: string, mathContent: MathContent[], openEditor = false) {
    super(MESSAGE.MSGTYPE.MATH_CONTENT, fromGuid, { mathContent: mathContent, openEditor: openEditor });
  }
}

export class MathOpenMessage extends ShellMessage {
  constructor(fromGuid: string, mathOpen = false) {
    super(MESSAGE.MSGTYPE.MATH_OPEN, fromGuid, { mathOpen: mathOpen });
  }
}

export class MathContent {
  constructor(
    public mathLatex: string,
    public mathML: string,
    public mathImage: MathImage | null,
    public plainLatex: string,
  ) { }
}

export class MathImage {
  constructor(
    public base64: string,
    public width: number,
    public height: number,
    public isError: boolean,
    public errorMessage: string,
    public latex: string = ''
  ) { }

  static fromBase64(base64: string, width: number, height: number, latex: string = ''): MathImage {
    return new MathImage(base64, width, height, false, '', latex);
  }

  static error(message: string): MathImage {
    return new MathImage('', 0, 0, true, message);
  }
}

export class ToastMessage extends ShellMessage {
  constructor(fromGuid: string, message: string, action: string) {
    super(MESSAGE.MSGTYPE.TOAST_MESSAGE, fromGuid, { message: message, action: action });
  }
}

export class TtsEnableMessage extends ShellMessage {
  constructor(fromGuid: string, ttsEnable: boolean) {
    super(MESSAGE.MSGTYPE.ENABLE_TTS, fromGuid, {
      ttsEnable: ttsEnable
    });
  }
}

export class PlayMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.PLAY, fromGuid, {});
  }
}

export class PlayResponseMessage extends ShellMessage {
  constructor(fromGuid: string, caller: string, text: string, language: string) {
    super(MESSAGE.MSGTYPE.PLAY_RESPONSE, fromGuid, { caller: caller, text: text, language: language });
  }
}

// 1, -1, 100
export class ZoomMessage extends ShellMessage {
  constructor(fromGuid: string, zoom: number) {
    super(MESSAGE.MSGTYPE.ZOOM, fromGuid, { zoom: zoom });
  }
}

export class FindInDocMessage extends ShellMessage {
  constructor(fromGuid: string, activeFind: boolean) {
    super(MESSAGE.MSGTYPE.FIND_IN_DOC, fromGuid, { activeFind: activeFind });
  }
}

export class PrintMessage extends ShellMessage {
  constructor(fromGuid: string, print: boolean) {
    super(MESSAGE.MSGTYPE.PRINT, fromGuid, { print: print });
  }
}

export class ConvertToImageMessage extends ShellMessage {
  constructor(fromGuid: string, qrCode: boolean) {
    super(MESSAGE.MSGTYPE.CONVERT_TO_IMAGE, fromGuid, { qrCode: qrCode });
  }
}

export class SelectionChangeMessage extends ShellMessage {
  constructor(fromGuid: string, hasSelection: boolean, selectionType: string, text: string) {
    super(MESSAGE.MSGTYPE.SELECTION_CHANGE, fromGuid, { hasSelection: hasSelection, selectionType: selectionType, text });
  }
}

export class SpeakMessage extends ShellMessage {
  constructor(fromGuid: string, caller: CALLER, text: string, language: string, forceSpeaking?: boolean, speechRate: number = -1, voice?: SpeechSynthesisVoice) {
    super(MESSAGE.MSGTYPE.SPEAK, fromGuid, { caller: caller, text: text, language: language, forceSpeaking: forceSpeaking, speechRate: speechRate, voice: voice });
  }
}

export class StopSpeakMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.STOP_SPEAK, fromGuid, {});
  }
}

export class TalkingStartMessage extends ShellMessage {
  constructor() {
    super(MESSAGE.MSGTYPE.TALKING_START, 'shell-tts', {});
  }
}

export class TalkingEndMessage extends ShellMessage {

  constructor(byUser: boolean) {
    super(MESSAGE.MSGTYPE.TALKING_END, 'shell-tts', { byUser: byUser });
  }
}

export class TtsBoundaryMessage extends ShellMessage {
  constructor(boundary: any) {
    super(MESSAGE.MSGTYPE.TTS_BOUNDARY, 'shell-tts', { boundary: boundary });
  }
}

export class CopySelectionMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.COPY_SELECTION, fromGuid, {});
  }
}
export class CopyResponseMessage extends ShellMessage {
  // constructor(fromGuid: string, selectionType: string, selection: any, text?: string, image?: any) {
  constructor(fromGuid: string, selectionData: SelectionDataDto) {
    // const msgData = { selectionData : selectionData };

    super(MESSAGE.MSGTYPE.COPY_RESPONSE, fromGuid, { msgData: selectionData });
  }
}

export class PasteSelectionMessage extends ShellMessage {
  constructor(fromGuid: string, selectionData: SelectionDataDto) {
    super(MESSAGE.MSGTYPE.PASTE_SELECTION, fromGuid, selectionData);
  }
}

// export class PasteSelectionAsDeepMessage extends ShellMessage {
//   constructor(fromGuid: string, selection: any) {
//     super(MESSAGE.MSGTYPE.PASTE_SELECTION_AS_DEEP, fromGuid, selection);
//   }
// }

export class SearchSelectionMessage extends ShellMessage {
  constructor(fromGuid: string, selection: string) {
    super(MESSAGE.MSGTYPE.SEARCH_SELECTION, fromGuid, selection);
  }
}
export class ImageMapRequestMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.IMAGE_MAP_REQUEST, fromGuid, {});
  }
}

export class ImageMapResponseMessage extends ShellMessage {
  constructor(fromGuid: string, imageData: ImageDataDto) {
    super(MESSAGE.MSGTYPE.IMAGE_MAP_RESPONSE, fromGuid, { image: imageData });
  }
}
export class LanguageChangedMessage extends ShellMessage {
  constructor(fromGuid: string, language: string) {
    super(MESSAGE.MSGTYPE.LANGUAGE_CHANGED, fromGuid, { language: language });
  }
}

export class SpeechRecognitionToMapMessage extends ShellMessage {
  constructor(fromGuid: string, isEnabled: boolean) {
    super(MESSAGE.MSGTYPE.SPEECH_RECOGNITION_TO_MAP, fromGuid, { isEnabled: isEnabled });
  }
}

export class SpeechRecognitionToShellMessage extends ShellMessage {
  constructor(fromGuid: string, isEnabled: boolean) {
    super(MESSAGE.MSGTYPE.SPEECH_RECOGNITION_TO_SHELL, fromGuid, { isEnabled: isEnabled });
  }
}

export class SpeechRecognitionTextMessage extends ShellMessage {
  constructor(fromGuid: string, text: string) {
    super(MESSAGE.MSGTYPE.SPEECH_RECOGNITION_TEXT, fromGuid, { text: text });
  }
}

export class ImageInsertMessage extends ShellMessage {
  constructor(fromGuid: string, imageData: ImageDataDto) {
    super(MESSAGE.MSGTYPE.IMAGE_INSERT, fromGuid, imageData);
  }
}


export class ImageMapInsertMessage extends ShellMessage {
  constructor(fromGuid: string, image: string) {
    super(MESSAGE.MSGTYPE.IMAGE_MAP_INSERT, fromGuid, image);
  }
}

export class RequestCropMessage extends ShellMessage {
  constructor() {
    super(MESSAGE.MSGTYPE.REQUEST_CROP_IMAGE, 'workspace', {});
  }
}

export class ModuleCropMessage extends ShellMessage {
  constructor(fromGuid: string, base64: string, left: number = 0, top: number = 0, right: number = 0, bottom: number = 0) {
    super(MESSAGE.MSGTYPE.MODULE_CROP_RECEIVED, fromGuid, { base64: base64, left: left, top: top, right: right, bottom: bottom });
  }
}

export class LockDocMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string) {
    super(MESSAGE.MSGTYPE.LOCK_DOC, fromGuid, { docId: docId });
  }
}

export class EditImageMessage extends ShellMessage {
  constructor(fromGuid: string, base64: string) {
    super(MESSAGE.MSGTYPE.EDIT_IMAGE, fromGuid, { base64: base64 });
  }
}

export class CropPasteImageMessage extends ShellMessage {
  constructor(fromGuid: string, base64: string) {
    super(MESSAGE.MSGTYPE.CROP_PASTE_IMAGE_DIALOG, fromGuid, { base64: base64 });
  }
}

export class BeforeExitMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.BEFORE_EXIT, fromGuid, {});
  }
}

export class NetworkErrorMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.NETWORK_ERROR, fromGuid, {});
  }
}

export class FilePickerRequestMessage extends ShellMessage {
  constructor(fromGuid: string, docType: 'map' | 'doc' | 'pdf', nodeId: string, nodeText: string) {
    super(MESSAGE.MSGTYPE.DOC_PICKER_REQUEST, fromGuid, { docType: docType, nodeId: nodeId, nodeText: nodeText });
  }
}

export class FilePickerResponseMessage extends ShellMessage {
  constructor(fromGuid: string, docId: string, docType: string, docName: string) {
    super(MESSAGE.MSGTYPE.DOC_PICKER_RESPONSE, fromGuid, { docId: docId, docType: docType, docName: docName });
  }
}

export class RequestLoginMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.REQUEST_LOGIN, fromGuid, {});
  }
}

export class CredentialRequestSimpleMessage extends ShellMessage {
  constructor(fromGuid: string) {
    super(MESSAGE.MSGTYPE.REQUEST_CREDENTIALS_SIMPLE, fromGuid, {});
  }
}

export class CredentialResponseSimpleMessage extends ShellMessage {
  constructor(fromGuid: string, msgData: any) {
    super(MESSAGE.MSGTYPE.RESPONSE_CREDENTIALS_SIMPLE, fromGuid, msgData);
  }
}

export class MapFragmentCopiedMessage extends ShellMessage {
  constructor(fromGuid: string, mapFragment: any) {
    super(MESSAGE.MSGTYPE.MAP_FRAGMENT_COPIED, fromGuid, mapFragment);
  }
}
export class ImportDocFromLocalMessage extends ShellMessage {
  constructor(fromGuid: string, file: File, attach: boolean = false) {
    super(MESSAGE.MSGTYPE.IMPORT_DOC_FROM_LOCAL, fromGuid, { file: file, attach: attach });
  }
}

export class SetTabTitleMessage extends ShellMessage {
  constructor(fromGuid: string, title: string) {
    super(MESSAGE.MSGTYPE.SET_TAB_TITLE, fromGuid, { title: title });
  }
}

export class AttachNewDocMessage extends ShellMessage {
  constructor(fromGuid: string, nodeId: string, newDocId: string, newDocType: string) {
    super(MESSAGE.MSGTYPE.ATTACH_NEW_DOC, fromGuid, { nodeId: nodeId, newDocId: newDocId, newDocType: newDocType });
  }
}
